export function hasShippableItems(checkout) {
  return checkout.lineItems?.some(lineItem => lineItem.physicalProperties?.shippable) ?? false;
}
//# sourceMappingURL=hasShippableItems.js.map